import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { ISortableCell } from "@ryde/shared";

import { HeaderCellSortable } from "../../cell-templates";
import { IHeaderPopover } from "../../context-panels";

export const GenericSortableCell = ({
  children,
  fieldNameResolved,
  groupingDisabled,
  sortingDisabled,
  translationKey,
}: ISortableCell): ReactElement => {
  const cellProps: IHeaderPopover = {
    fieldNameResolved,
    groupingDisabled,
    sortingDisabled,
  };
  const { t } = useTranslation();
  return (
    <HeaderCellSortable {...cellProps}>
      {translationKey ? t(translationKey) : children}
    </HeaderCellSortable>
  );
};
